import React, { type FunctionComponent } from 'react'
import { Text } from 'ic-snacks'
import { css } from '@emotion/react'

const rowContainerStyles = css({
  margin: '4px 0px',
})

export type LabeledNumberProps = {
  label: string
  value: string
}

export const LabeledNumber: FunctionComponent<LabeledNumberProps> = ({ label, value }) => {
  return (
    <div css={rowContainerStyles}>
      <Text
        elementType="span"
        variant="T.16"
        style={{ width: 100, fontWeight: 'bold', display: 'inline-block' }}
      >
        {label}
      </Text>
      <Text elementType="span" variant="T.16">
        {value}
      </Text>
    </div>
  )
}
